<div class="photo">
  <img class="photo__image"
    [src]="src"
    [alt]="alt"
  >
</div>
